import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Toaster, toast } from "react-hot-toast";

/* -------------------- CONFIG -------------------- */
const BASE_URL = process.env.REACT_APP_BASEURL;
/* -------------------- COMPONENT -------------------- */

function ReferralAmounts() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const [loading, setLoading] = useState(false);

    /* -------------------- GET REFERRAL AMOUNT -------------------- */

    const fetchReferralAmounts = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const res = await axios.get(`${BASE_URL}/admin/referralAmounts`, {
                headers: {
                    Authorization: token,
                },
            });

            const data = res?.data?.data;

            if (data) {
                setValue("referralReferrerAmount", data.referrerAmount);
                setValue("referralRefereeAmount", data.refereeAmount);
            }
        } catch (err) {
            toast.error("Failed to load referral amount");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReferralAmounts();
    }, []);

    /* -------------------- UPDATE REFERRAL AMOUNTS -------------------- */

    const onSubmit = async (formData) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const payload = {
                referralReferrerAmount: Number(formData.referralReferrerAmount),
                referralRefereeAmount: Number(formData.referralRefereeAmount),
            };

            const res = await axios.patch(
                `${BASE_URL}/admin/referralAmounts`,
                payload,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res?.data?.success) {
                toast.success("Referral amount updated successfully");
            } else {
                toast.error("Update failed");
            }
        } catch (err) {
            toast.error("Something went wrong while updating");
        } finally {
            setLoading(false);
        }
    };

    /* -------------------- UI -------------------- */

    return (
        <>
            <Toaster position="top-right" />

            <div className="card-body">
                <h2 className="mb-4">Referral Amount Management</h2>

                <form className="row g-4" onSubmit={handleSubmit(onSubmit)}>
                    {/* Referrer Amount */}
                    <div className="col-md-6">
                        <label className="form-label">Referrer Reward Amount</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter referrer amount"
                            {...register("referralReferrerAmount", {
                                required: "Referrer amount is required",
                                min: { value: 1, message: "Amount must be greater than 0" },
                            })}
                        />
                        {errors.referralReferrerAmount && (
                            <span className="text-danger">
                                {errors.referralReferrerAmount.message}
                            </span>
                        )}
                    </div>

                    {/* Referee Amount */}
                    <div className="col-md-6">
                        <label className="form-label">Referee Reward Amount</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter referee amount"
                            {...register("referralRefereeAmount", {
                                required: "Referee amount is required",
                                min: { value: 1, message: "Amount must be greater than 0" },
                            })}
                        />
                        {errors.referralRefereeAmount && (
                            <span className="text-danger">
                                {errors.referralRefereeAmount.message}
                            </span>
                        )}
                    </div>

                    {/* Submit */}
                    <div className="col-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update Amounts"}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default ReferralAmounts;
